// Phase 86T — Tenant/User delete blocker mesajlarını TR/EN olarak frontend'de
// çevir. Backend tarihsel olarak Türkçe sabit mesaj döndürüyor; bu utility
// `code` + `details` üzerinden dile uygun mesajı üretir.
//
// Backend her blocker objesinde `code` ve `details` alanlarını gönderir; bu
// sayede sayı/email gibi dinamik değerleri JS tarafında interpolate edebiliyoruz.
// Bilinmeyen bir code geldiğinde, geriye dönük uyumluluk için backend'in
// orijinal `message` string'ine düşeriz (Türkçe de olsa görünür).

/**
 * @param {{ code?: string, message?: string, details?: any }} blocker
 * @param {boolean} tr - true ise Türkçe, false ise İngilizce
 * @returns {string}
 */
export function translateBlocker(blocker, tr) {
  if (!blocker) return '';
  const code = blocker.code || '';
  const d = blocker.details || {};
  const count = (Array.isArray(d) ? d.length : (d.count ?? 0)) || 0;

  switch (code) {
    case 'platform_tenant':
      return tr
        ? "Bu, SummitFlow platform tenant'ıdır — Ultra Admin platform ürünlerini barındırır. ASLA silinemez."
        : 'This is the SummitFlow platform tenant — it hosts Ultra Admin platform products. NEVER deletable.';
    case 'protected_user': {
      const email = (d && d.email) || '';
      return tr
        ? `Bu tenant'ta korumalı kullanıcı var: ${email}`
        : `This tenant has a protected user: ${email}`;
    }
    case 'active_orders':
      return tr
        ? `${count} adet aktif/kesinleşmiş sipariş var. Bunlar silinemez.`
        : `${count} active/confirmed order(s) exist. They cannot be deleted.`;
    case 'active_stand_assignment':
      return tr
        ? `${count} adet atanmış stand var. Önce stand ataması iptal edilmeli.`
        : `${count} assigned stand(s). Unassign the stand(s) first.`;
    case 'paid_transactions':
      return tr
        ? `${count} adet tamamlanmış ödeme kaydı var. Silinemez.`
        : `${count} completed payment record(s). Not deletable.`;
    case 'paid_service_orders':
      return tr
        ? `${count} ödenmiş stand servis siparişi var. Silinemez (önce iade işlemi).`
        : `${count} paid stand-service order(s). Not deletable (refund first).`;
    case 'approved_service_orders':
      return tr
        ? `${count} onaylanmış (ödeme bekleyen) stand servis siparişi var.`
        : `${count} approved stand-service order(s) pending payment.`;
    case 'submitted_service_orders':
      return tr
        ? `${count} onay bekleyen stand servis siparişi var. Önce reddedilmeli.`
        : `${count} stand-service order(s) awaiting approval. Reject first.`;
    default:
      return blocker.message || '';
  }
}

/** Toast/lines için blockers listesini bullet'lı string'e çevirir. */
export function blockersToBullets(blockers, tr) {
  if (!Array.isArray(blockers) || blockers.length === 0) return '';
  return blockers.map(b => `• ${translateBlocker(b, tr)}`).join('\n');
}
